/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from 'vue-property-decorator'
import { getReviewList, setIsDeleteById, delReviewById } from '@/api/common'
import { formatDate } from '@/utils/timeFilter'
import { NewReviewModule } from '@/store/modules/newReview'
import {delNullProperty} from "@/utils";
import {getRoleAuthority} from "@/api/authority";

@Component({
    filters: {
        timeFormat: (val: string) => (formatDate('yyyy-MM-dd', new Date(val)))
    }
})
export default class ReviewSettinges extends Vue {
    // ------ 变量 ------
    reviewList: any = []
    page = 1
    total = 0
    limit = 20
    loading = false
    delApprovalId = NaN
    delApprovalDialogShow = false
    functionsLevel1Id = null
    isDelete = null
    approvalTypesList = []

    // ------ 生命周期 ------
    created() {
        this.getReviewList()
        this.getFunctions1()
    }

    // ------ 方法 ------
    async getReviewList() {
        this.loading = true
        const data: any = await getReviewList(delNullProperty({
            page: this.page,
            limit: this.limit,
            functionsLevel1Id: this.functionsLevel1Id,
            isDelete: this.isDelete,
        }))
        this.reviewList = data.reviewList
        this.loading = false
        this.total = data.allNum
    }

    async getFunctions1() {
        const data: any = await getRoleAuthority({id: 0})
        this.approvalTypesList = data.filter(item => item.isReview)
    }
    changePage(val: number) {
        this.page = val
        this.getReviewList()
    }
    async setIsDeleteById(status: number, id: number) {
        await setIsDeleteById({ status, id })
        this.$message.success(`当前审批流已经${status === 1 ? '禁用' : '启用' }`)
        this.getReviewList()
    }
    handleDelete(id){
        this.delApprovalId = id
        this.delApprovalDialogShow = true
    }
    async delRefundDialogConfirm() {
        await delReviewById({id:this.delApprovalId})
        this.delApprovalId = NaN
        this.delApprovalDialogShow = false
        this.$message.success('删除成功')
        this.getReviewList()
    }

    editorApproval(id: number) {
        // NewReviewModule.setStepsAvtive(0)
        // this.$router.push('/newReview?id=' + id)
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/newReview?id=' + id+ '&isEdit=1')
        const time = setInterval(() => {
            if(win.closed) {
                this.getReviewList()
                clearInterval(time)
            }
        }, 500)
    }

    newReview() {
        const win =  window.open(window.location.origin + this.$route.matched[0].path + '/newReview')
        const time = setInterval(() => {
            if(win.closed) {
                this.getReviewList()
                clearInterval(time)
            }
        }, 500)
    }
}
